import moment from 'moment-timezone';
import {FormGroup} from '@angular/forms';
import {fromEvent} from 'rxjs';
import {map} from 'rxjs/operators';

export class Utils {
  static formatDate(dt: Date, format: string = 'DD/MM/YYYY') {
    return moment(dt).format(format);
  }

  static toUTCThenFormat(dt: Date, format = 'yyyy-MM-DDTHH:mm:ss') {
    return moment(dt).utc().format(format);
  }

  static validateDate(dt, format: string = 'DD/MM/YYYY') {
    return moment(dt, format, true).isValid();
  }

  static isBrNumeric(input){
    let RE = /^-{0,1}\d*,{0,1}\d+$/;
    return (RE.test(input));
  }

  static zoneAndDateParse(dt: Date, format: string = 'DD/MM/YYYY') {
    if (!dt) { return ''; }
    const timeZone = moment.tz.guess();
    return moment.utc(dt).tz(timeZone).format(format);
  }

  static adjustSpaces(text: string, form: FormGroup, formControlName: any) {
    // faço o split, filter e join, para remover todos os espaços a mais entre as palavras
    const value = text.split(' ').filter(f => f !== '').join(' ');
    // atualizar o campo com o valor acertado, caso necessário
    form.controls[formControlName].patchValue(value);
  }

  static adjustDate(isInitialDate = true, form: FormGroup, formControlInitDate: any, formControlFinalDate: any) {
    let initDateTime = form.controls[formControlInitDate].value;
    let finalDateTime = form.controls[formControlFinalDate].value;

    const iniDt = initDateTime.split('T');
    const finDt = finalDateTime.split('T');
    if (iniDt[0] == finDt[0]) {
      if (isInitialDate) {
        if (iniDt[1] > finDt[1]) {
          form.controls[formControlInitDate].setValue(finalDateTime);
        }
      } else {
        if (finDt[1] < iniDt[1]) {
          form.controls[formControlFinalDate].setValue(initDateTime);
        }
      }
    }
  }

  static defineBodyScroll(showModal: boolean) {
    // Se o modal estiver aberto, devo esconder o scroll da tela de trás.
    if (showModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }

  static onDialogClick(event: UIEvent) {
    // Capture click on dialog and prevent it from bubbling to the modal background.
    event.stopPropagation();
    event.cancelBubble = true;
  }

  static mapOut(sourceObject, removeKeys = []) {
    const sourceKeys = Object.keys(sourceObject);
    const returnKeys = sourceKeys.filter(k => !removeKeys.includes(k));
    let returnObject = {};
    returnKeys.forEach(k => {
      returnObject[k] = sourceObject[k];
    });
    return returnObject;
  }

  static closeColorPickerDialog(querySelector) {
    const content = document.querySelector(querySelector);
    const scroll$ = fromEvent(content, 'scroll').pipe(map(() => content));
    scroll$.subscribe(element => {
      const colorPickerOpen = <HTMLElement>document.querySelector('.color-picker.open');
      if (colorPickerOpen !== null) {
        colorPickerOpen.classList.remove('open');
        colorPickerOpen.style.display = 'none';
      }
    });
  }

  static closeFilter() {
    // recolher os filtros, para melhor visualização do resultado
    document.getElementById('cardFilter').classList.add('collapsed-card');
    document.getElementById('bodyFilter').style.display = 'none';
    document.getElementById('footerFilter').style.display = 'none';

    // fechar o filtro
    const collapseFilter = document.getElementById('collapseFilter');
    collapseFilter.classList.add('fa-plus');
    collapseFilter.classList.remove('fa-minus');
  }

}
